import './App.css';
import React from 'react';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom';

import { AuthProvider } from './AuthContext';
import AuthContext from './AuthContext';

import ProtectedRoute from './ProtectedRoute';

import Login from './components/Login';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Register from './components/Register';

import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Changepassword from './pages/Changepassword';
import Billing from './pages/Billing';
import Cancelbill from './pages/Cancelbill';
import Dailyreport from './pages/Dailyreport';
import Bulkbill from './pages/Bulkbill';
import Bulksearchbill from './pages/Bulksearchbill';
import Buyer from './pages/Buyer';
import Bulkupload from './pages/Bulkupload';
import Dealer from './pages/Dealer';
import Searchbill from './pages/Searchbill';
import Superdealer from './pages/Superdealer';


const AppContent = () => {

  const {
    isAuthenticated,
    loading
  } = React.useContext(AuthContext);

  const location = useLocation();

  const userType = localStorage.getItem('user_type');

  const isLoginPage = location.pathname === '/login';


  // ==========================================
  // WAIT FOR AUTH CHECK
  // ==========================================
  if (loading) {
    return <div>Loading...</div>;
  }


  // ==========================================
  // PROTECTED ROUTES
  // ==========================================
  const protectedRoutes = [

    {
      path: '/dashboard',
      element: <Dashboard />
    },

    {
      path: '/billing',
      element: <Billing />
    },

    {
      path: '/bulkbill',
      element: <Bulkbill />
    },

    {
      path: '/bulksearchbill',
      element: <Bulksearchbill />
    },

    {
      path: '/buyer',
      element: <Buyer />
    },

    {
      path: '/cancelbill',
      element: <Cancelbill />
    },

    {
      path: '/changepassword',
      element: <Changepassword />
    },

    {
      path: '/dailyreport',
      element: <Dailyreport />
    },

    {
      path: '/profile',
      element: <Profile />
    },

    {
      path: '/bulk-upload',
      element: <Bulkupload />
    },

    {
      path: '/dealer',
      element: <Dealer />
    },

    {
      path: '/search-bill',
      element: <Searchbill />
    },

    {
      path: '/super-dealer',
      element: <Superdealer />
    }

  ];


  // ==========================================
  // LOGIN PAGE
  // ==========================================
  if (isLoginPage) {

    return (
      <Routes>

        <Route
          path="/login"
          element={
            isAuthenticated
              ? (
                String(userType) === '4'
                  ? (
                    <Navigate
                      to="/dealer"
                      replace
                    />
                  )
                  : (
                    <Navigate
                      to="/dashboard"
                      replace
                    />
                  )
              )
              : <Login />
          }
        />

      </Routes>
    );
  }


  return (

    <div className="App">

      <div className="wrapper">


        {/* ==========================================
            HEADER
        =========================================== */}
        {isAuthenticated && <Header />}


        {/* ==========================================
            SIDEBAR
        =========================================== */}
        {isAuthenticated && <Sidebar />}


        {/* ==========================================
            ROUTES
        =========================================== */}
        <Routes>


          {/* ==========================================
              LOGIN
          =========================================== */}
          <Route
            path="/login"
            element={<Login />}
          />


          {/* ==========================================
              REGISTER
          =========================================== */}
          <Route
            path="/register"
            element={<Register />}
          />


          {/* ==========================================
              ROOT
              
              Type 4 -> Dealer
              Other users -> Dashboard
          =========================================== */}
          <Route
            path="/"
            element={

              isAuthenticated

                ? (

                  String(userType) === '4'

                    ? (
                      <Navigate
                        to="/dealer"
                        replace
                      />
                    )

                    : (
                      <Navigate
                        to="/dashboard"
                        replace
                      />
                    )

                )

                : (
                  <Navigate
                    to="/login"
                    replace
                  />
                )
            }
          />


          {/* ==========================================
              PROTECTED ROUTES
          =========================================== */}
          {protectedRoutes.map((route) => (

            <Route
              key={route.path}
              path={route.path}
              element={
                <ProtectedRoute>
                  {route.element}
                </ProtectedRoute>
              }
            />

          ))}


        </Routes>


        {/* ==========================================
            CONTROL SIDEBAR
        =========================================== */}
        <aside className="control-sidebar control-sidebar-dark">
        </aside>


        {/* ==========================================
            FOOTER
        =========================================== */}
        {isAuthenticated && <Footer />}


      </div>

    </div>
  );
};


const App = () => (

  <AuthProvider>

    <Router>

      <AppContent />

    </Router>

  </AuthProvider>

);


export default App;